
let BaseTest = require('@/mixins/Forms/2016/BaseTest')

module.exports = {

    mixins: [BaseTest],

    data () {
        return {
            testResult: 0,
            spaces: [],
        }
    },

    mounted(){
        this.loadFormData();
        this.resolveTest();
    },

    methods: {

        constructionInspection(){
            var checkbox_1 = $('input[name="controlled_lighting_system_can_be_limited"]:checked').val() ? true : false;
            var checkbox_2 = $('input[name="controlled_lighting_does_not_override_the_maximum_light_output"]:checked').val() ? true : false;
            var checkbox_3 = $('input[name="controls_are_not_readily_accessible"]:checked').val() ? true : false;
            return checkbox_1 && checkbox_2 && checkbox_3;
        },

        removeSpace(){
            if(this.canRemoveSpaces) {
                this.spaces.pop();
            }
        },

        loadFormData () {
            axios.get(`${window.location.href}/data`).then(response => {
                if (response.data.data) {
                    for (var i = 0; i < response.data.data.number_of_spaces; i++) {
                        this.loadSpaceData(i, response.data.data);
                    }
                }
                if (this.spaces.length == 0) {
                    this.addSpace();
                }
            })
        },
    },

    computed:{
        canRemoveSpaces(){
            return this.spaces.length > 1;
        }
    }

}


//// Check wish radio is checked so, we disabled other checkboxes on radios
//radiosOnConstructionInspection: function () {
//    var value = $('input[name="what_type_of_controls_of_controlling_the_maximum_output_of_luminaires"]:checked').val();
//}
